/*
 * jQuery buylist cart
 * 
 * By charlie
 * 
 * License is granted exclusively to FlipSide Gaming to use this software. 
 * Any other use is forbidden without the consent of the author.
 * 
 */
(function ( $, window, document, undefined ) {
	// serializeObject plugin
	$.fn.serializeObject=function(){"use strict";var a={},b=function(b,c){var d=a[c.name];"undefined"!=typeof d&&d!==null?$.isArray(d)?d.push(c.value):a[c.name]=[d,c.value]:a[c.name]=c.value};return $.each(this.serializeArray(),b),a};
    console.log('running');
	// set defaults
	var pluginName = "buylistCart",
		defaults = {
			prefix: 'fs-buylist',
			getImageUrl: function(handle, game, callback) { },
			imgUrlTransform: function(url, size) { return url; },
			onBuylistSubmit: function(data, form, event) { },
			minBuylistQty: 5,
			language: {
				emptyBuylist: 'Your buylist is empty.',
				belowMinQty: 'You do not have enough items in your buylist to proceed. '
			}
		};

	// The actual plugin constructor
	function Buylist( element, options ) {
		this.element = element;
		this.options = $.extend( {}, defaults, options) ;
		this.prefix = this.options.prefix + '-';

		this._defaults = defaults;
		this._name = pluginName;

		this.init();
	}

	// plugin object defintion
	Buylist.prototype = {

		init: function() {
			// do buylist initialization if this is our first time
			if (!this.isBuylistCartInitialized())
				this.initializeBuylistCart(this.options);

			// set up click event for targeted element
			var that = this;
			var element = $(this.element);
			element.on('click', function() {
				var handle = element.data('handle');
				var item = {
					handle: handle,
					game: element.data('game'),
					name: element.data('name'),
					set: element.data('set'),
					condition: element.data('condition'),
					price: element.data('price'),
					max: element.data('max'),
					image: element.data('image')
				};

				var quantity = element.data('quantity') || 1;
				var newQty = that.addItemQty(item, quantity);

				if (item.image === undefined || item.image == '') {
					that.options.getImageUrl(item.handle.slice(0, -3), item.game, function(imgUrl) {
						that.updateItemImage(item.handle, imgUrl);
						element.data('image', imgUrl);
					});
				}
			});
		},

		// one-time initialization logic
		initializeBuylistCart: function(userOptions) {
			var that = this;
			var options = that.options;
			
			this.drawBuylistModal();			
			this.updateBuylistInfoFields();

			// initialize one-time events
			$('.' + that.prefix + 'cart-icon').click(function() {
				that.showBuylistModal();
			});

			$('.' + that.prefix + 'cart-view').click(function() {
				that.showBuylistModal();
			});

           
			
          
			$(document).on("input", '.' + that.prefix + 'item-quantity', function () {
				var price = $(this).closest("tr").data("price");
				var handle = $(this).closest("tr").data("handle");
				var quantity = $(this).val();

				$(this).parent("td").next('.' + that.prefix + 'cart-item-total').text("$" + (price * quantity / 100.0).toFixed(2));
				that.updateItemQty({ handle: handle }, quantity);

				$('.' + that.prefix + 'cart-badge').text(that.getTotalQuantity());
			});

			$(document).on('keypress', '.' + that.prefix + 'item-quantity', function(evt) {
				if (evt.keyCode == 38 || evt.keyCode == 40) { 
					return ;
				}
				evt.preventDefault();
			});

			$(document).on('click', '.' + that.prefix + 'item-remove', function() {
				var $tr = $(this).closest('tr');
				var handle = $tr.data('handle');
				$tr.hide(500, function() {
					that.removeItem(handle);
					that.drawTable();
				});
			});

			$('#' + that.prefix + 'modal-nextstep').click(function() {
				var buylist = that.getBuylist();
				if (!buylist.length || (that.getGrandTotal(buylist) < (that.options.minBuylistQty * 100.0))) {
					that.flashCartMessage(that.options.language.belowMinQty);
					return;
				}

				that.gotoModalStep(2, 'Step 2 - Provide Contact Information');
			});

			$('#' + that.prefix + 'clear-cart').click(function() {
				that.clearBuylist();
            });

			$('#' + that.prefix + 'modal-prevstep').click(function() {
				that.gotoModalStep(1, 'Step 1 - Review Your Buylist');
			});

			$('#' + that.prefix + 'modal-submit').click(function() {
				var buylist = that.getBuylist();
				if (!buylist.length) {
					that.flashCartMessage(that.options.language.belowMinQty);
					return;
				}
				
				$('#' + that.prefix + 'modal-form').submit();
			});
		},

		isBuylistCartInitialized: function() {
			return $('#' + this.prefix + 'cart-modal').length;
		},

		dateReviver: function(key,value) {
			var a;
			if (key === 'timestamp' && typeof value === 'string') {
				a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
				if (a) {
					return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
				}
			}
			return value;
		},

		getBuylist: function() {
			var data = { };
			try {
				data = JSON.parse(localStorage.getItem('fsg-buylist'), this.dateReviver) || { };
				if (!data.buylist || (data.timestamp && (Math.abs(new Date() - data.timestamp) / 36e5) >= 8.5)) {
					data.buylist = [];
				}
			} catch (e) {
				data.buylist = [];
			}
			return data.buylist;
		},
		
		setBuylist: function(buylist) {
			var data = { buylist: buylist, timestamp: new Date() };
			localStorage.setItem('fsg-buylist', JSON.stringify(data));
			this.updateBuylistInfoFields(buylist);
		},

		tryGetItemIndex: function(handle) {
			var itemIndex = false;
			var buylist = this.getBuylist();
			$.each(buylist, function(index, value) { if (value.handle == handle) itemIndex = index; });
			return itemIndex;
		},

		addItemQty: function(item, quantity) {
			var buylist = this.getBuylist();
			var idx = this.tryGetItemIndex(item.handle);
			var newQty;
			quantity = (typeof quantity === "undefined" ? 1 : quantity ) * 1;
			if (idx === false) {
				item.quantity = Math.min(quantity, item.max);
				buylist.push(item);
				newQty = item.quantity;
			} else {
				buylist[idx].quantity = Math.min((buylist[idx].quantity * 1) + quantity, buylist[idx].max);
				newQty = buylist[idx].quantity;
			}
			this.setBuylist(buylist);
			return newQty;
		},

		updateItemQty: function(item, quantity) {
			var buylist = this.getBuylist();
			var idx = this.tryGetItemIndex(item.handle);
			quantity = quantity * 1;
			if (idx === false) {
				item.quantity = Math.min(quantity, item.max);
				buylist.push(item);
			} else {
				buylist[idx].quantity = Math.min(quantity, buylist[idx].max);
			}
			this.setBuylist(buylist);
			return quantity;
		},

		removeItem: function(handle) {
			var buylist = this.getBuylist();
			buylist = $.grep(buylist, function(value, index) {
				return value.handle != handle;
			});
			$('.' + this.prefix + 'table-item-qty[data-handle="' + handle + '"]').html('');
			this.setBuylist(buylist);
		},

		clearBuylist: function() {
			this.setBuylist([]);
		},

		updateItemImage: function(handle, imageUrl) {
			var buylist = this.getBuylist();
			var idx = this.tryGetItemIndex(handle);
			if (idx === false) return false;

			buylist[idx].image = imageUrl;
			this.setBuylist(buylist);
			return true;
		},

		updateBuylistInfoFields: function(buylist) {
			if (buylist === undefined) buylist = this.getBuylist();
			var gt = (this.getGrandTotal(buylist) / 100.0).toFixed(2);
			$('.' + this.prefix + 'cart-grand-total').html('<strong>$' + (this.getGrandTotal(buylist) / 100.0).toFixed(2) + '</strong>');
			$('.' + this.prefix + 'cart-badge').text(this.getTotalQuantity(buylist));

			this.updateBuylistTableFields(buylist);
		},

		updateBuylistTableFields: function(buylist) {
			var that = this;
			if (buylist === undefined) buylist = this.getBuylist();
			$('.' + that.prefix + 'table-item-qty').html('');
			$.each(buylist, function(index, value) {
				$('.' + that.prefix + 'table-item-qty[data-handle="' + value.handle + '"]').html(value.quantity > 0 ? '' + value.quantity + ' <em>in list</em>' : '');
			});
		},

		getTotalQuantity: function(buylist) {
			if (buylist === undefined) buylist = this.getBuylist();
			var total = 0;
			$.each(buylist, function(index, value) {
				total += value.quantity * 1;
			});
			return total;
		},

		getGrandTotal: function(buylist) {
			if (buylist === undefined) buylist = this.getBuylist();
			var total = 0;
			$.each(buylist, function(index, value) {
				total += value.quantity * value.price;
			});
			return total;
		},

		sortbyTitle: function(a, b) {
			if (a.name < b.name)
				return -1;
			if (a.name > b.name)
				return 1;
			return 0;
		},

		drawTable: function() {
			var that = this;
			var itemTableBody = $('#' + this.prefix + 'cart-table').find('tbody');
			itemTableBody.empty();

			var buylist = this.getBuylist();
			buylist.sort(this.sortbyTitle);
			$.each(buylist, function() {
				var total = this.quantity * this.price;
				itemTableBody.append(
					'<tr title="' + this.name + ' -- ' + this.condition + '" data-handle="' + this.handle + '" data-price="' + this.price + '">\
						<td class="text-center">\
							<img class="img-responsive m-xs" src="' + that.options.imgUrlTransform(this.image, 'thumb') + '"/>\
						</td>\
						<td>' + this.name + ' -- ' + this.condition + '<br><small>' + this.set + '</small></td>\
						<td title="Buy Price">$' + (this.price / 100.0).toFixed(2) + '</td>\
						<td title="Quantity">\
							<input type="number" min="1" max="' + this.max + '" style="width: 30px;" class="' + that.prefix + 'item-quantity' + '" value="' + this.quantity + '"/>\
						</td>\
						<td title="Total" class="' + that.prefix + 'cart-item-total' + '">$' + (total / 100.0).toFixed(2) + '</td>\
						<td title="Remove from List" class="text-center">\
							<a href="javascript:void(0);" class="fs-buylist-cart-icon ' + that.prefix + 'item-remove">\
							<i class="fa fa-trash fa-lg" aria-hidden="true"></i></a>\
						</td>\
					</tr>'
				);
			});

			if (!buylist.length) {
				$('#' + this.prefix + 'empty-banner').show();
			} else {
				$('#' + this.prefix + 'empty-banner').hide();
			}
		},
		
		getHashFromString: function(str) {
			var hash = 0;
			if (str.length == 0) return hash;
			for (i = 0; i < str.length; i++) {
				char = str.charCodeAt(i);
				hash = ((hash<<5)-hash)+char;
				hash = hash & hash; // Convert to 32bit integer
			}
			return hash;
		},

		flashCartMessage: function(msg) {
			var hash = this.getHashFromString(msg);
			if (!$('#' + this.prefix + 'cart-msg-' + hash).length)
			{
				$('<div class="alert alert-danger ' + this.prefix + 'cart-msg" role="alert" id="' + this.prefix + 'cart-msg-' + hash + '">' + msg + '</div>').hide()
					.appendTo('#' + this.prefix + 'modal-warning').fadeIn(400, function() { 
						$(this).delay(3500).fadeOut(400, function() { 
							$(this).remove();
						}); 
					});
			}
		},

		drawBuylistModal: function() {
			var countryOptions = $.map(this.countryList, function(value, index) { return '<option value="' + value + '">' + value + '</option>'; }).join('');
			$('body').append(
				'<div class="modal fade" id="' + this.prefix + 'cart-modal' + '" tabindex="-1" role="dialog" aria-labelledby="' + this.prefix + 'modal-title">\
					<div class="modal-dialog" role="document">\
						<div class="modal-content">\
							<div class="modal-header">\
								<button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>\
								<h4 class="modal-title" id="' + this.prefix + 'modal-title">\
									<i class="fa fa-shopping-basket fa-lg mr-sm" aria-hidden="true"></i>\
									<span id="' + this.prefix + 'modal-title">Step 1 - Review Your Buylist</span>\
								</h4>\
							</div>\
							<div class="modal-body">\
								<div class="' + this.prefix + 'modal-pane" id="' + this.prefix + 'modal-pane-1">\
									<div id="' + this.prefix + 'modal-warning"></div>\
									<table class="table table-hover table-responsive" id="' + this.prefix + 'cart-table' + '">\
										<thead class="bluebg white uppercase">\
											<th colspan="2">Card Name</th>\
											<th>Buy Price</th>\
											<th>Qty</th>\
											<th>Subtotal</th>\
											<th></th>\
										</thead>\
										<tbody></tbody>\
										<tfoot class="bluebg white uppercase">\
											<tr>\
												<th colspan="4" class="text-right"><strong>Total</strong></th>\
												<td><strong class="' + this.prefix + 'cart-grand-total' + '">$0.00</strong></td>\
												<td></td>\
											</tr>\
										</tfoot>\
									</table>\
									<div class="text-center">\
										<span id="' + this.prefix + 'empty-banner">' + this.options.language.emptyBuylist + '</span>\
									</div>\
								</div>\
								<div class="' + this.prefix + 'modal-pane" id="' + this.prefix + 'modal-pane-2" style="display:none;">\
									<p></p>\
									<form id="' + this.prefix + 'modal-form" class="form-horizontal" role="form">\
										<div class="form-group">\
											<div class="col-sm-12">\
												<label for="' + this.prefix + 'form-full-name">Full Name</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-full-name" name="full-name" placeholder="Full name" required>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-6">\
												<label for="' + this.prefix + 'form-email">Email</label>\
												<input type="email" class="form-control" id="' + this.prefix + 'form-email" name="email" placeholder="Email" required>\
											</div>\
											<div class="col-sm-6">\
												<label for="' + this.prefix + 'form-phone-number">Phone Number</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-phone-number" name="phone-number">\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-12">\
												<label for="' + this.prefix + 'form-street-address-1">Street Address</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-street-address-1" name="street-address-1" placeholder="Street Address" required>\
											</div>\
											<div class="col-sm-12">\
												<label for="' + this.prefix + 'form-street-address-2" class="sr-only">Street Address (cont.)</label>\
												<input type="text" class="form-control mt-sm" id="' + this.prefix + 'form-street-address-2" name="street-address-2" placeholder="Street Address (cont.)">\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-8">\
												<label for="' + this.prefix + 'form-city">City</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-city" name="city" placeholder="City" required>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-7">\
												<label for="' + this.prefix + 'form-state-region">State / Province / Region</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-state-region" name="state-region" placeholder="State, province or region" required>\
											</div>\
											<div class="col-sm-5">\
												<label for="' + this.prefix + 'form-postal-code">ZIP / Postal Code</label>\
												<input type="text" class="form-control" id="' + this.prefix + 'form-postal-code" name="postal-code" placeholder="Postal code">\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-8">\
												<label for="' + this.prefix + 'form-country">Country</label>\
												<select id="' + this.prefix + 'form-country" class="form-control" name="country" required>\
													<option value="" disabled selected>Select a country</option>' + 
													countryOptions + 
												'</select>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-12">\
												<label for="payment-method-container" class="mb-none">Payment Method</label>\
												<div id="payment-method-container">\
													<label class="radio-inline">\
														<input type="radio" name="payment-method" id="' + this.prefix + 'form-payment-check" value="check" required> Check\
													</label>\
													<label class="radio-inline">\
														<input type="radio" name="payment-method" id="' + this.prefix + 'form-payment-paypal" value="paypal" required> PayPal <small>(4% fee applies)</small>\
													</label>\
												</div>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-12">\
												<div class="checkbox">\
													<label id="hold-for-approval-label">\
														<input type="checkbox" name="hold-for-approval" id="' + this.prefix + 'form-hold-for-approval" value="hold">\
														Hold changes for approval\
													</label>\
												</div>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-12">\
												<div class="checkbox">\
													<label id="toc-agreement-label">\
														<input type="checkbox" name="toc-agreement" id="' + this.prefix + 'form-toc-agreement" value="agree" required>\
														I have read and agree to the Flipside Gaming buylist <a class="mr-xs" id="toc-view-link" href="/pages/selling-cards-to-flipside" target="_blank">terms and conditions.</a>\
													</label>\
												</div>\
											</div>\
										</div>\
										<div class="form-group">\
											<div class="col-sm-12">\
												<label for="' + this.prefix + 'street-form-notes">Notes</label>\
												<textarea class="form-control" id="' + this.prefix + 'form-notes" rows="5" name="notes" placeholder="Anything else to add? Let us know here!"></textarea>\
											</div>\
										</div>\
									</form>\
								</div>\
								<div class="' + this.prefix + 'modal-pane" id="' + this.prefix + 'modal-pane-3" style="display:none;">\
									<div class="row">\
										<div class="col-sm-12" id="' + this.prefix + 'modal-alert-container"></div>\
									</div>\
								</div>\
							</div>\
							<div class="modal-footer">\
								<button type="button" class="btn btn-flipside-white btn-modal btn-modal-s1 btn-modal-s2 btn-modal-s3" id="' + this.prefix + 'modal-close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Close</button>\
								<button type="button" class="btn btn-flipside-white btn-modal btn-modal-s1" id="' + this.prefix + 'clear-cart" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Clear Buylist Cart</button>\
								<button type="button" class="btn btn-flipside-white btn-modal btn-modal-s2" id="' + this.prefix + 'modal-prevstep" style="display:none;"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>\
								<button type="button" class="btn btn-primary btn-modal btn-modal-s1" id="' + this.prefix + 'modal-nextstep">Next <i class="fa fa-arrow-right" aria-hidden="true"></i></button>\
								<button type="button" class="btn btn-primary btn-modal btn-modal-s2" id="' + this.prefix + 'modal-submit" style="display:none;">Submit</button>\
							</div>\
						</div>\
					</div>\
				</div>');
			
			// form validation 
			var that = this;
			$('#' + this.prefix + 'modal-form').validate({
				submitHandler: function(form, event) {
					var data = {
						buylist: that.getBuylist(),
						contact: $(form).serializeObject()
					};

					try {
						__adroll.record_user({"adroll_segments": "6f6ca4fb"})    
					} catch(err) { }

					$.when(that.options.onBuylistSubmit(data), that.gotoModalStep(3, 'Processing...', 200))
						.done(function() { that.onSubmitSuccess(); })
						.fail(function() { that.onSubmitError(); });
				},
				errorPlacement: function(error, element) {
					switch (element.attr('name')) {
						case 'payment-method':
							error.insertAfter($('#payment-method-container').get(0));
							break;
						case 'toc-agreement':
							error.insertAfter($('#toc-view-link').get(0));
							break;
						default:
							error.insertAfter(element.get(0));
					}
				}
			});
		},

		showBuylistModal: function() {
			this.drawTable();
			$('#' + this.prefix + 'cart-modal').modal('show');
		},

		gotoModalStep: function(step, titleText, speed) {
			var that = this;
			speed = speed || 400;
			if (step === undefined) return $.Deferred().resolve().promise();
			return $.when(
				$.when($('#' + that.prefix + 'modal-title').fadeOut(speed).promise())
					.then(function() { $('#' + that.prefix + 'modal-title').text(titleText).fadeIn(speed); }),
				$.when($('.' + that.prefix + 'modal-pane:not(#' + that.prefix + 'modal-pane-' + step + ')').fadeOut(speed).promise())
					.then(function() { $('#' + that.prefix + 'modal-pane-' + step).fadeIn(speed); }),
				$.when($('.btn-modal:not(.btn-modal-s' + step + ')').fadeOut(speed).promise())
					.then(function() { $('.btn-modal-s' + step).fadeIn(speed); }));
		},

		clearContactForm: function() {
			$('#' + this.prefix + 'modal-form')[0].reset();
		},


      
      flashFinalMessage: function(msg, style, speed) {
			var that = this;
			style = style || 'success';
			speed = speed || 400;

			$('#' + this.prefix + 'modal-alert-container .alert').fadeOut(speed, function() { $(this).remove(); });
			return $('#' + this.prefix + 'modal-alert-container .alert').promise().done(function() {
				$('<div class="alert alert-' + style + ' text-center">' + msg + '</div>')
					.hide()
					.appendTo('#' + that.prefix + 'modal-alert-container')
					.delay(speed + 100)
					.fadeIn(speed);
				});
		},

		onSubmitSuccess: function(data) {
			var that = this;
			$('#' + this.prefix + 'modal-title').fadeOut(400, function() { 
				$('#' + that.prefix + 'modal-title').text('Your buylist has been successfully submitted').fadeIn(400); 
			});

			var msg = '<p><strong>Thank You!</strong></p>' +
				  '<p>Your buylist was successfully submitted! We will reach out to you within one business day.</p>' +
				  '<p>If you have any questions or would like to speak with us further regarding your submission, you may email us at ' +
				  '<strong>buyer@flipsidegaming.com</strong>.</p>' +
				  '<p>You may <a href="#" id="' + this.prefix + 'success-done" class="alert-link" data-dismiss="modal">click here</a> to close this window.<p>';

			this.flashFinalMessage(msg, 'success')
				.done(function() {
					$('#' + that.prefix + 'success-done').click(function () { that.gotoModalStep(1, 'Step 1 - Review Your Buylist'); });
				});

			this.clearBuylist();
			this.updateBuylistTableFields();
			this.clearContactForm();
		},
		
		onSubmitError: function(request) {
			var that = this;
			$('#' + this.prefix + 'modal-title').fadeOut(400, function() { 
				$('#' + that.prefix + 'modal-title').text('There was a problem submitting your buylist').fadeIn(400); 
			});

			var msg = 'There was a problem submitting your buylist. Please <a href="#" class="alert-link" id="' + that.prefix + 
					  'error-back">go back and try again</a>.<br>' +
					  'If the problem persists, please email us at <strong>buyer@flipsidegaming.com</strong>. Sorry for the inconvenience!';
			
			this.flashFinalMessage(msg, 'warning')
				.done(function() {
					$('#' + that.prefix + 'error-back').click(function () { that.gotoModalStep(2, 'Step 2 - Provide Contact Information'); });
				});
		},

		countryList: ["United States", "Canada", "Afghanistan","Aland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia, Plurinational State of","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo, The Democratic Republic of the","Cook Islands","Costa Rica","Cote d'Ivoire","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran, Islamic Republic of","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea, Democratic People's Republic of","Korea, Republic of","Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libyan Arab Jamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia, The Former Yugoslav Republic of","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia, Federated States of","Moldova, Republic of","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Occupied Palestinian Territory","Oman","Pakistan","Palau","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russian Federation","Rwanda","Saint Barthelemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and The Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Swaziland","Sweden","Switzerland","Syrian Arab Republic","Taiwan, Province of China","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela, Bolivarian Republic of","Viet Nam","Virgin Islands, British","Virgin Islands, U.S.","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]
	};

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function ( options ) {
		var updated = false;
		return this.each(function () {
			var instance = $.data(this, "plugin_" + pluginName);
			if (!instance) {
				$.data(this, "plugin_" + pluginName, new Buylist( this, options ));
			} else if (!updated){
				instance.updateBuylistTableFields();
				updated = true;	
			} 
		});
	};

})( jQuery, window, document );